import { MINUTE_MS } from './constants';

// A bucket's average is its own time over its own card count — the Overview tile's
// range-wide average would be a flat line and say nothing per bucket.
export function withAverage(buckets) {
  return buckets.map((bucket) => {
    const count = bucket.time_tracked_cards_count || 0;

    return {
      ...bucket,
      average_time_per_card_ms: count > 0 ? Math.round((bucket.time_spent_ms || 0) / count) : 0,
    };
  });
}

// Whole-minute ticks, so no two labels round to the same minute: formatDuration rounds
// to whole minutes, so recharts' default fractional ticks would collapse into duplicate
// "1m"/"2m" labels on small ranges. Both duration series share this axis, so the max
// spans both — the average can only equal the total, never exceed it, but reading both
// keeps the ticks correct if that ever stops holding.
export function buildYTicks(data) {
  const max = Math.max(
    0,
    ...data.map((bucket) => Math.max(bucket.time_spent_ms || 0, bucket.average_time_per_card_ms || 0))
  );
  const step = Math.max(MINUTE_MS, Math.ceil(max / 4 / MINUTE_MS) * MINUTE_MS);
  const ticks = [];

  for (let tick = 0; tick <= max + step; tick += step) ticks.push(tick);

  return ticks;
}
